
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teams",
      function () {
        return require("private-next-pages/teams/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teams"])
      });
    }
  